export default __webpack_public_path__ + "static/N0107-ef06b09248ec4960657dffe5857a2e0a.png";